export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_API_URI = process.env.REACT_APP_API_URL;
export const BASE_API_V2_URI = process.env.REACT_APP_API_V2_URL;
export const BASE_REPORT_SCHEDULER_URI = process.env.REACT_APP_REPORT_SCHEDULER_API_URL;
export const BASE_PASS_KEY = process.env.REACT_APP_PASS_KEY;
export const BASE_SSN_KEY = process.env.REACT_APP_SSN_KEY;
export const BASE_SOCKET_URI = process.env.REACT_APP_SOCKET_URL;
export const BASE_MUI_KEY = process.env.REACT_APP_MUI_KEY;
export const BASE_WS_API_TOKEN = process.env.REACT_APP_WS_API_TOKEN;
export const BASE_PWC_API_URL = process.env.REACT_APP_PWC_API_URL;
export const BASE_PWC_WSS_API_URL = process.env.REACT_APP_PWC_WSS_API_URL;
export const BASE_API_V2_WSS_URL = process.env.REACT_APP_API_V2_WSS_URL;
export const BASE_IDENTITY_API_URL = process.env.REACT_APP_IDENTITY_API_URL;
export const USE_IDENTITY = process.env.REACT_APP_USE_IDENTITY;
export const IDENTITY_CLIENT_ID = process.env.REACT_APP_IDENTITY_CLIENT_ID;
export const BASE_STIMULUS_KEY = process.env.REACT_APP_STIMULUS_KEY;
export const BASE_STIMULSOFT_URL = process.env.REACT_APP_STIMULSOFT_REPORT_URL;
export const S3_REPORTS_URL = process.env.REACT_APP_S3_REPORTS_BASE_URL;
export const S3_LOGOS_BASE_URL = process.env.REACT_APP_S3_LOGOS_BASE_URL;
export const BASE_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT;
export const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION ?? "local";
export const POSTHOG_KEY = process.env.REACT_APP_PUBLIC_POSTHOG_KEY;
export const POSTHOG_HOST = process.env.REACT_APP_PUBLIC_POSTHOG_HOST;
export const PANDADOC_API_URI = process.env.REACT_APP_PANDADOC_API_URL;
export const PANDADOC_API_KEY = process.env.REACT_APP_PANDADOC_API_KEY;
export const ETA671_TEMPLATE_UUID = process.env.REACT_APP_ETA671_TEMPLATE_UUID;

export const DEFAULT_SIZE = 4;
export const STAUTES = Object.freeze({
  PENDING: "pending",
  SUCCESS: "success",
  ERROR: "error",
  LOADING: "loading",
  IDLE: "idle"
});

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE = 1;
export const DETAULT_ROLE = "Admin";
export const EMPLOYEE_ROLE = "Employee";
export const DEFAULT_DATE_FORMAT = "MM/DD/YYYY";
export const DEFAULT_TIME_FORMAT = "hh:mm A";
export const DEFAULT_DATE_PAYLOAD_FORMAT = "YYYY-MM-DD";
export const DEFAULT_TIME_ZONE = "Europe/London";
export const CONTRUCTION_TYPE = "Heavy";
export const GRID_FEATURE_MODE_SERVER = "server";
export const GRID_FEATURE_MODE_CLIENT = "client";

// Debounce delays in milliseconds
export const SEARCH_DEBOUNCE_DELAY = 800;
export const FILTER_DEBOUNCE_DELAY = 800;

// CSS color
export const COLOR = {
  editButton: "#1f88e6",
  editButtonBg: "#f5f5f5"
};

//FOOTER ENVIRONMENT CONFIG
export const ENVIRONMENT_CONFIG = {
  prod: {
    label: null,
    chip: { bgcolor: "#E6F4EA", color: "#1E7E34", border: "1px solid #B7E1C1" }
  },
  dev: {
    label: "Dev",
    chip: { bgcolor: "#F1F3F5", color: "#495057", border: "1px solid #DEE2E6" }
  },
  demo: {
    label: "Demo",
    chip: { bgcolor: "#F1F3F5", color: "#495057", border: "1px solid #DEE2E6" }
  },
  qa: {
    label: "QA",
    chip: { bgcolor: "#E3F2FD", color: "#1565C0", border: "1px solid #BBDEFB" }
  },
  sandbox: {
    label: "Sandbox",
    chip: { bgcolor: "#FFF4E5", color: "#B26A00", border: "1px solid #FFD8A8" }
  },
  "moss-sandbox": {
    label: "UAT",
    chip: { bgcolor: "#FFF4E5", color: "#B26A00", border: "1px solid #FFD8A8" }
  }
};

export const DEFAULT_ALLOWED_FILE_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "image/jpeg",
  "image/png"
];

export const FILE_TYPE_LABELS = {
  "application/pdf": "PDF",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "DOCX",
  "image/jpeg": "JPG, JPEG",
  "image/png": "PNG"
};
